.root {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
  justify-self: flex-end;
  width: 100%;
  padding-top: 6px;
  margin-top: auto;
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-regular);
}
